export const categories = [
  {
    slug: 'dianying',
    name: '电影',
    icon: 'ri-film-line',
    description: '海量高清电影资源，涵盖动作、喜剧、科幻、爱情等多种类型',
    count: 2856,
  },
  {
    slug: 'dianshiju',
    name: '电视剧',
    icon: 'ri-tv-line',
    description: '热门电视剧全集在线观看，每日更新，追剧首选',
    count: 3421,
  },
  {
    slug: 'zongyi',
    name: '综艺',
    icon: 'ri-emotion-laugh-line',
    description: '最新综艺节目高清完整版，热门综艺一网打尽',
    count: 1567,
  },
  {
    slug: 'dongman',
    name: '动漫',
    icon: 'ri-ghost-line',
    description: '国产动漫、日本动漫高清在线，热血、治愈、冒险应有尽有',
    count: 4230,
  },
  {
    slug: 'jilupian',
    name: '纪录片',
    icon: 'ri-earth-line',
    description: 'BBC、央视等顶级纪录片，探索自然、历史与人文',
    count: 892,
  },
  {
    slug: 'tiyu',
    name: '体育',
    icon: 'ri-basketball-line',
    description: 'NBA、英超、中超等体育赛事高清回放与集锦',
    count: 654,
  },
];

export const categorySlugMap: Record<string, string> = {
  dianying: '电影',
  dianshiju: '电视剧',
  zongyi: '综艺',
  dongman: '动漫',
  jilupian: '纪录片',
  tiyu: '体育',
};